import { Zoom } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import React, { useEffect, useRef, useState } from 'react';
import { getImage, ImageSize } from '../../../shared/utils/imageFormat';

const useStyles = makeStyles((theme: Theme) => ({
  img: {
    position: 'absolute',
    padding: 8,
    backgroundColor: '#ffffff',
    borderRadius: 2,
    // border: '1px solid #666',
    filter: `drop-shadow(1px 1px 9px rgba(0, 0, 0, 0.3))`,
    '& img': {
      width: '100%',
      display: 'block',
    },
  },
}));

//   const Transition = forwardRef(function Transition(props, ref) {
//     return <Slide direction="up" ref={ref} {...props} />;
//   });

export const ImageRandomPosition = ({
  src,
  containerWidth,
  containerHeight,
  conferenceId,
  fill = 0.7,
}: {
  src: string;
  containerWidth: number;
  containerHeight: number;
  conferenceId: string;
  fill?: number;
}) => {
  const classes = useStyles();
  const ref = useRef<HTMLImageElement>();
  const [loaded, setLoaded] = useState<boolean>(false);
  const [position, setPosition] = useState<{
    top: number;
    left: number;
    width: number | string;
    // height: number | string;
  } | null>(null);

  const onLoad = () => {
    setLoaded(true);
  };

  useEffect(() => {
    if (loaded) {
      // setPosition()
      const containerRatio = containerHeight / containerWidth;
      const ratio = ref.current.naturalHeight / ref.current.naturalWidth;
      // Set the image at random position inside the container

      let width, height;
      if (ratio > containerRatio) {
        height = containerHeight * fill;
        width = height / ratio;
      } else {
        width = containerWidth * fill;
        height = width * ratio;
      }
      const left = (containerWidth - width) * Math.random();
      const top = (containerHeight - height) * Math.random();

      setPosition({ top, left, width });
    }
  }, [loaded, containerWidth, containerHeight]);

  return (
    <Zoom in={position !== null}>
      <div
        className={classes.img}
        style={{ visibility: position ? 'visible' : 'hidden', ...position }}
      >
        <img
          ref={ref}
          src={getImage(src, ImageSize.Large, conferenceId)}
          onLoad={onLoad}
        />
      </div>
    </Zoom>
  );
};
ImageRandomPosition.displayName = 'ImageRandomPosition';
